import { render } from "./InvalidAccount.vue?vue&type=template&id=0e4bb0f2&scoped=true&ts=true"
import script from "./InvalidAccount.vue?vue&type=script&lang=ts"
export * from "./InvalidAccount.vue?vue&type=script&lang=ts"

import "./InvalidAccount.vue?vue&type=style&index=0&id=0e4bb0f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e4bb0f2"]])

export default __exports__